import { FormEvent } from 'react';
import { OneOfFilterValueType } from '../../Filter/OneOFilter';
import { OptionsFilterViewProps, OptionsType } from './AbstractFilterView';
import { AbstractToggleFilter } from './AbstractToggleFilter';
import { FilterEvent } from './FilterEvent';
import { InputType } from './Toggle/Item';

interface CheckboxFilterProps<VALUE_TYPE, OPTION_TYPE> extends OptionsFilterViewProps<VALUE_TYPE, OPTION_TYPE> {
}

export type CheckboxFilterType = OneOfFilterValueType

export class CheckboxFilter<VALUE_TYPE extends CheckboxFilterType, OPTION_TYPE> extends AbstractToggleFilter<VALUE_TYPE, CheckboxFilterProps<VALUE_TYPE, OPTION_TYPE>, OPTION_TYPE> {
    protected getType(): InputType {
        return 'checkbox';
    }

    protected getOptions(): OptionsType<OPTION_TYPE> {
        return this.props.options;
    }

    protected handleInputChange(event: FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        const item = target.name;
        const isChecked = target.checked;

        const props = this.props;
        const checkedItems: CheckboxFilterType = props.filter ? props.filter.value.slice(0) : [];

        const indexOfItem = checkedItems.indexOf(item);
        const alreadyInArray = indexOfItem > -1;

        if (alreadyInArray && !isChecked) {
            checkedItems.splice(indexOfItem, 1);
        } else if (!alreadyInArray && isChecked) {
            checkedItems.push(item);
        }

        const formEvent = new FilterEvent(event, checkedItems);
        this.handleChange<CheckboxFilterType>(formEvent);
    }
}
